<template>
  <div class="paper-edit">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="editForm" :model="model"
          :rules="modelValidate"
          label-position="left"
          :label-width="140">
          <FormItem label="试卷标题" prop="title">
            <Input v-model="model.title" placeholder="输入试卷标题" />
          </FormItem>
          <FormItem label="最早开始答题时间" prop="startDate">
            <DatePicker :value="model.startDate" @on-change="changeStartDate" type="datetime" placeholder="请选择"></DatePicker>
          </FormItem>
          <FormItem label="答题截止时间" prop="endDate">
            <DatePicker :value="model.endDate" @on-change="changeEndDate" type="datetime" placeholder="请选择"></DatePicker>
          </FormItem>
          <FormItem label="评分表达式" prop="scoreFormula">
            <Input v-model="model.scoreFormula" placeholder="输入评分表达式" />
            <span><a href="https://mathjs.org/docs/expressions/syntax.html" target="_blank">https://mathjs.org/docs/expressions/syntax.html</a></span>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from '../../api/Api.js'
export default {
  name: 'question-edit',
  props: {
  },
  data () {
    return {
      loading: false,
      model: {
        id: null,
        title: null,
        startDate: null,
        endDate: null,
        scoreFormula: null,
      },
      modelValidate: {
        title: [
          { required: true, message: '请填写标题', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
    this.getDetail()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    changeStartDate (dt) {
      if (dt) {
        this.model.startDate = this.$moment(dt).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.model.startDate = null
      }
    },
    changeEndDate (dt) {
      if (dt) {
        this.model.endDate = this.$moment(dt).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.model.endDate = null
      }
    },
    getDetail () {
      if (this.$route.params.id) {
        this.loading = true
        this.$Spin.show()
        Api.Appraisal.getAppraisalPaper(this.$route.params.id).then((payload) => {
          this.model = payload
          this.model.id = payload.tid
          this.loading = false
          this.$Spin.hide()
        })
        .catch(err => {
          console.log('err', err)
          this.$Message.error('提交失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
        })
      }
    },
    async submit () {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Appraisal.editAppraisalPaper(this.model)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('修改成功!')
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
